webpackJsonp([1],{

/***/ "+FQu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+aTo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+vjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_my_dropdown_vue__ = __webpack_require__("ZISC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75ed0f25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_my_dropdown_vue__ = __webpack_require__("0i1y");
function injectStyle (ssrContext) {
  __webpack_require__("BW7l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_my_dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75ed0f25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_my_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "//BD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsolvedDoubts_vue__ = __webpack_require__("RRA2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750ef171_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsolvedDoubts_vue__ = __webpack_require__("KS9U");
function injectStyle (ssrContext) {
  __webpack_require__("AQC7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-750ef171"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnsolvedDoubts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750ef171_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnsolvedDoubts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0i1y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('transition',{attrs:{"name":_vm.animation}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"my-dropdown-dd",style:(_vm.ddStyle)},[_vm._t("dropdown")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "123g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssignedDoubts_vue__ = __webpack_require__("Z8WG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26239bce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssignedDoubts_vue__ = __webpack_require__("CL0g");
function injectStyle (ssrContext) {
  __webpack_require__("NX0l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26239bce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssignedDoubts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26239bce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AssignedDoubts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1fK9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+Of":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoubtView_vue__ = __webpack_require__("W/Ui");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c58e6f88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoubtView_vue__ = __webpack_require__("7YJ9");
function injectStyle (ssrContext) {
  __webpack_require__("duna")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c58e6f88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoubtView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c58e6f88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoubtView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7TRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("CSaD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_139b8cf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("dxfU");
function injectStyle (ssrContext) {
  __webpack_require__("+aTo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-139b8cf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_139b8cf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7YJ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"doubtView"}},[_c('div',{staticClass:"solution-wrapper"},[(_vm.current_doubt.doubt_status=='completed')?_c('span',{staticClass:"green-bg solved"},[_vm._v("Solved ✓")]):_c('span',{staticClass:"yellow-bg unsolved"},[_vm._v("Pending!")]),_vm._v(" "),_c('h5',{staticStyle:{"margin-top":"10px"}},[_vm._v(_vm._s(_vm.current_doubt.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.current_doubt.description))]),_vm._v(" "),(_vm.current_doubt.attachment_filename != '' && _vm.current_doubt.attachment_filename != null)?_c('div',[_c('p',[_vm._v("Attachment:")]),_vm._v(" "),(_vm.img_source == '')?_c('loader'):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","display":"block"},attrs:{"src":_vm.img_source}})],1):_vm._e(),_vm._v(" "),_c('div',[(_vm.current_doubt.doubt_status=='completed')?_c('div',[_c('h4',{staticStyle:{"margin-top":"20px"}},[_vm._v("Solution:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.solution.description))])]):_vm._e(),_vm._v(" "),(_vm.current_doubt.doubt_status=='pending')?_c('div',[_c('h4',{staticStyle:{"margin-top":"20px"}},[_vm._v("Solution:")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Enter something","rows":3,"max-rows":6},model:{value:(_vm.form.solution_description),callback:function ($$v) {_vm.$set(_vm.form, "solution_description", $$v)},expression:"form.solution_description"}}),_vm._v(" "),_c('b-form-file',{staticStyle:{"margin-top":"20px"},attrs:{"state":Boolean(_vm.solution_attachment_file_obj),"placeholder":"Choose a file..."},model:{value:(_vm.solution_attachment_file_obj),callback:function ($$v) {_vm.solution_attachment_file_obj=$$v},expression:"solution_attachment_file_obj"}}),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn button-touchy",staticStyle:{"margin-top":"20px","margin-left":"0"},attrs:{"variant":"primary"},on:{"click":_vm.execute_add_solution}},[_vm._v("Submit Answer")])],1):_vm._e(),_vm._v(" "),(_vm.solution.attachment_filename != '' && _vm.solution_img_source == '' && _vm.solution.attachment_filename != null)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.solution_img_source != '')?_c('div',[_c('img',{staticStyle:{"width":"100%","display":"block"},attrs:{"src":_vm.solution_img_source}})]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7j0/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello bg-light",attrs:{"id":"login"}},[_c('div',{attrs:{"id":"login_wrapper"}},[_c('b-container',{staticClass:"margin-auto rounded",attrs:{"id":"hero"}},[_c('b-row',[_c('b-col',{staticClass:"logo-col hero-col",attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"qds-logo",attrs:{"id":"art"}},[_c('a',{attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"static/logo.png"}})])])]),_vm._v(" "),_c('b-col',{staticClass:"bg-green ctl center hero-col",attrs:{"sm":"12","lg":"6"}},[_c('div',{attrs:{"id":"the_form"}},[_c('h1',{staticStyle:{"margin-bottom":"2rem"}},[_vm._v("Faculty Login")]),_vm._v(" "),_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"exampleInput1","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"email","required":"","placeholder":"Enter email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"exampleInput1","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"password","required":"","placeholder":"Password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('b-button',{staticClass:"btn-blue",attrs:{"size":"lg","variant":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("Login")]),_c('br'),_c('br')],1)],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7lyR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9jM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loader loader--style1",staticStyle:{"text-align":"center"},attrs:{"title":"Loading"}},[_c('svg',{attrs:{"version":"1.1","id":"loader-1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"40px","height":"40px","viewBox":"0 0 40 40","enable-background":"new 0 0 40 40","xml:space":"preserve"}},[_c('path',{attrs:{"opacity":"0.2","fill":"#000","d":"M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n\t    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n\t    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n\t    C22.32,8.481,24.301,9.057,26.013,10.047z"}},[_c('animateTransform',{attrs:{"attributeType":"xml","attributeName":"transform","type":"rotate","from":"0 20 20","to":"360 20 20","dur":"0.5s","repeatCount":"indefinite"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AQC7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BW7l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C8U/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_my_dropdown__ = __webpack_require__("+vjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Solutions',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      enable_filters: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    get_human_date: function get_human_date(d) {
      var mom = __WEBPACK_IMPORTED_MODULE_1_moment___default()(d);
      return mom.format('LL');
    }
  },
  selected: null,
  search: ''
});

/***/ }),

/***/ "CL0g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"solutions"}},[_c('div',{staticClass:"solution-wrapper"},[_c('b-container',{staticClass:"solution-header",attrs:{"fluid":""}},[(_vm.enable_filters)?_c('b-row',[_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Tag Subject")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Option A")]),_vm._v(" "),_c('option',{attrs:{"value":"b","disabled":""}},[_vm._v("Option B (disabled)")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Grouped Options"}},[_c('option',{domProps:{"value":{'C':'3PO'}}},[_vm._v("Option  object value")]),_vm._v(" "),_c('option',{domProps:{"value":{'R':'2D2'}}},[_vm._v("Another option with object value")])])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Chapter")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("A to Z")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Z to A")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Low Star")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("High Star")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Date")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Accending")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Decending")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"search","required":"","placeholder":"Query Name"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-button',{staticClass:"query-btn",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)])],1):_vm._e()],1),_vm._v(" "),_c('h4',[_vm._v("Assigned Doubts")]),_vm._v(" "),_vm._l((_vm.unsolved_doubts),function(doubt,index){return _c('b-container',{key:doubt.id,staticClass:"solution-container",attrs:{"fluid":""}},[_c('b-link',{staticClass:"solution-link note",class:{'qds-active-border':doubt.doubt_status=='completed', noteactive:doubt.doubt_status=='completed'},attrs:{"to":'/dashboard/doubts/'+doubt.id}},[_c('b-row',[_c('b-col',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center"},attrs:{"lg":"2"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.get_human_date(doubt.created_at)))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('p',[_vm._v(_vm._s(doubt.title))]),_vm._v(" "),_c('p',{staticClass:"doubt-description"},[_c('span',{staticClass:"qds-dot qds-active"}),_vm._v(" "+_vm._s(doubt.description.slice(0,50))+"...")])]),_vm._v(" "),_c('b-col',{staticClass:"sol-rating",attrs:{"lg":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"1"}},[(doubt.doubt_status=='completed')?_c('span',{staticClass:"doubt-description sol-view"},[_vm._v("Solved")]):_c('span',{staticClass:"doubt-description sol-view"},[_vm._v("Pending")])])],1)],1)],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CLu7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"solutions"}},[_c('div',{staticClass:"solution-wrapper"},[_c('b-container',{staticClass:"solution-header",attrs:{"fluid":""}},[(_vm.enable_filters)?_c('b-row',[_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Tag Subject")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Option A")]),_vm._v(" "),_c('option',{attrs:{"value":"b","disabled":""}},[_vm._v("Option B (disabled)")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Grouped Options"}},[_c('option',{domProps:{"value":{'C':'3PO'}}},[_vm._v("Option  object value")]),_vm._v(" "),_c('option',{domProps:{"value":{'R':'2D2'}}},[_vm._v("Another option with object value")])])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Chapter")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("A to Z")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Z to A")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Low Star")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("High Star")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Date")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Accending")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Decending")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"search","required":"","placeholder":"Query Name"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-button',{staticClass:"query-btn",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)])],1):_vm._e()],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"center"},attrs:{"lg":"4"}},[_c('h4',{staticStyle:{"text-align":"center"}},[_vm._v("Total Credit")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.user.credits.credit))])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"center"},attrs:{"lg":"4"}},[_c('h4',{staticStyle:{"text-align":"center"}},[_vm._v("Total Debit")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.user.credits.debit))])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"center"},attrs:{"lg":"4"}},[_c('h4',[_vm._v("Balance")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.user.credits.credit - _vm.user.credits.debit))])])],1)],1),_vm._v(" "),_c('h4',{staticStyle:{"margin-top":"30px"}},[_vm._v("Transactions")]),_vm._v(" "),(_vm.loader)?_c('loader'):_vm._l((_vm.transactions),function(transaction,index){return _c('b-container',{key:transaction.id,staticClass:"solution-container",attrs:{"fluid":""}},[_c('b-link',{staticClass:"solution-link note"},[_c('b-row',[_c('b-col',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center"},attrs:{"lg":"2"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.get_human_date(transaction.created_at)))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('p',[_vm._v(_vm._s(transaction.reference))])]),_vm._v(" "),_c('b-col',{staticClass:"sol-rating",attrs:{"lg":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"1"}},[(transaction.debit  > 0)?_c('span',{staticClass:"doubt-description sol-view",staticStyle:{"color":"red"}},[_vm._v("-"+_vm._s(transaction.debit))]):_c('span',{staticClass:"doubt-description sol-view",staticStyle:{"color":"green"}},[_vm._v("+"+_vm._s(transaction.credit))])])],1)],1)],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CSaD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown__ = __webpack_require__("+vjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loader_vue__ = __webpack_require__("wd27");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dashboard',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      visible: false,
      slide_open: false,
      main_nav_visibility: false
    };
  },

  computed: {
    user_info: function user_info() {
      return this.$store.getters.user;
    }
  },
  components: {
    dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown__["a" /* default */],
    loader: __WEBPACK_IMPORTED_MODULE_3__Loader_vue__["a" /* default */]
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var user, action, action2;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:

              // keep main_nav open on desktop
              if (window.innerWidth > 1280) {
                this.main_nav_visibility = true;
              }

              user = this.$store.getters.user;

              if (user.is_logged_in) {
                _context2.next = 6;
                break;
              }

              this.$router.replace('/login');
              _context2.next = 11;
              break;

            case 6:
              _context2.next = 8;
              return this.$store.dispatch('fetch_me');

            case 8:
              action = _context2.sent;
              action2 = this.$store.dispatch('fetch_doubts');

              this.$router.replace('/dashboard/assigned');

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    logout: function logout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('logging out');
                _context3.next = 3;
                return _this.$store.dispatch('logout');

              case 3:
                _this.$toasted.show('Logged out successfully!', { type: 'success' });
                _this.$router.push('/login');

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }))();
    },
    open: function open() {
      this.slide_open = true;
    },
    close_main_nav: function close_main_nav() {
      this.main_nav_visibility = false;
    },
    goto: function goto(link) {
      if (window.innerWidth < 1280) this.main_nav_visibility = false;
      this.$router.push(link);
    }
  }
});

/***/ }),

/***/ "Gcsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),(_vm.global_loader)?_c('div',{attrs:{"id":"global_loader"}},[_c('div',{staticClass:"loader loader--style1",staticStyle:{"text-align":"center"},attrs:{"title":"Loading"}},[_c('svg',{attrs:{"version":"1.1","id":"loader-1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"40px","height":"40px","viewBox":"0 0 40 40","enable-background":"new 0 0 40 40","xml:space":"preserve"}},[_c('path',{attrs:{"opacity":"0.2","fill":"#000","d":"M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n        s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n        c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n        C22.32,8.481,24.301,9.057,26.013,10.047z"}},[_c('animateTransform',{attrs:{"attributeType":"xml","attributeName":"transform","type":"rotate","from":"0 20 20","to":"360 20 20","dur":"0.5s","repeatCount":"indefinite"}})],1)]),_vm._v(" "),_c('p',[_vm._v("Please wait")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GfHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H4WX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Overview',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro'
    };
  }
});

/***/ }),

/***/ "HHku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"solutions"}},[_c('div',{staticClass:"solution-wrapper"},[_c('b-container',{staticClass:"solution-header",attrs:{"fluid":""}},[(_vm.enable_filters)?_c('b-row',[_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Tag Subject")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Option A")]),_vm._v(" "),_c('option',{attrs:{"value":"b","disabled":""}},[_vm._v("Option B (disabled)")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Grouped Options"}},[_c('option',{domProps:{"value":{'C':'3PO'}}},[_vm._v("Option  object value")]),_vm._v(" "),_c('option',{domProps:{"value":{'R':'2D2'}}},[_vm._v("Another option with object value")])])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Chapter")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("A to Z")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Z to A")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Low Star")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("High Star")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Date")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Accending")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Decending")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"search","required":"","placeholder":"Query Name"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-button',{staticClass:"query-btn",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)])],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.user.doubts),function(doubt,index){return _c('b-container',{key:doubt.id,staticClass:"solution-container",attrs:{"fluid":""}},[_c('b-link',{staticClass:"solution-link note",class:{'qds-active-border':doubt.doubt_status=='completed', noteactive:doubt.doubt_status=='completed'},attrs:{"to":'/dashboard/doubts/'+doubt.id}},[_c('b-row',[_c('b-col',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center"},attrs:{"lg":"2"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.get_human_date(doubt.created_at)))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('p',[_vm._v(_vm._s(doubt.title))]),_vm._v(" "),_c('p',{staticClass:"doubt-description"},[_c('span',{staticClass:"qds-dot qds-active"}),_vm._v(" "+_vm._s(doubt.description.slice(0,50))+"...")])]),_vm._v(" "),_c('b-col',{staticClass:"sol-rating",attrs:{"lg":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"1"}},[(doubt.doubt_status=='completed')?_c('span',{staticClass:"doubt-description sol-view"},[_vm._v("Solved")]):_c('span',{staticClass:"doubt-description sol-view"},[_vm._v("Pending")])])],1)],1)],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HaSq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__("hydq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de1c7fa4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__("tjWM");
function injectStyle (ssrContext) {
  __webpack_require__("wP4/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de1c7fa4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de1c7fa4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I3Is":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"package-wrapper",attrs:{"id":"History"}},[_c('div',{staticClass:"add-query"},[_c('h2',[_vm._v("Packages")]),_vm._v(" "),_c('b-container',{staticClass:"package-container",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"package-item"},[_c('h3',{staticClass:"package-head"},[_vm._v("Newbie")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Q:")]),_vm._v(" "),_c('span',[_vm._v("200")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("R:")]),_vm._v(" "),_c('span',[_vm._v("5000/-")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Add on:")]),_vm._v(" "),_c('p',[_vm._v("- Tables upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Squares upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Cubes upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Unit Sheet")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Description")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\ntempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\nquis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\nconsequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\ncillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\nproident, sunt in culpa qui officia deserunt mollit anim id est laborum.")])])],1),_vm._v(" "),_c('b-button',{staticClass:"query-btn",attrs:{"to":"#","variant":"primary"}},[_vm._v("Know More")])],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IYGU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var axios_instance = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({});

var apiv1_endpoint = 'https://api.qdspro.com/v1';

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
	state: {
		user: {
			id: '',
			full_name: '',
			email: '',
			is_logged_in: false,
			credits: {
				credit: 0,
				debit: 0
			},
			blocked: "no",
			user_type: '',
			signup_datetime: '',
			doubts: []
		},
		global_loader: false,
		packages: [],
		doubts: [],
		transactions: []
	},
	getters: {
		user: function user(state) {
			return state.user;
		},
		global_loader: function global_loader(state) {
			return state.global_loader;
		},
		get_packages: function get_packages(state) {
			return state.packages;
		},
		unassigned_doubts: function unassigned_doubts(state) {
			var d = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(state.doubts, { 'assigned_expert_id': null, 'doubt_status': 'pending' });
			return d;
		},
		unsolved_doubts: function unsolved_doubts(state) {
			var d = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(state.doubts, { 'doubt_status': 'pending' });
			return d;
		},
		doubts: function doubts(state) {
			return state.doubts;
		},
		transactions: function transactions(state) {
			return state.transactions;
		}
	},
	mutations: {
		setToken: function setToken(state, token) {
			localStorage.setItem('token', token);
			axios_instance.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			return true;
		},
		removeToken: function removeToken(state) {
			localStorage.removeItem('token');
		},
		setUser: function setUser(state, user) {
			for (var property in state.user) {

				if (user.hasOwnProperty(property)) {
					state.user[property] = user[property];
				}
			}
		},
		setPackages: function setPackages(state, data) {
			state.packages = data;
		},
		setLoader: function setLoader(state, loading) {
			state.global_loader = loading;

			if (loading) {
				store.commit('disableBodyOverflow');
			} else {
				store.commit('enableBodyOverflow');
			}
		},
		disableBodyOverflow: function disableBodyOverflow(state) {
			document.body.classList.add('no-overflow');
		},
		enableBodyOverflow: function enableBodyOverflow(state) {
			document.body.classList.remove('no-overflow');
		},
		setDoubts: function setDoubts(state, data) {
			state.doubts = data;
		},
		setTransactions: function setTransactions(state, data) {
			state.transactions = data;
		}
	},
	actions: {
		add_solution: function add_solution(context, data) {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return axios_instance.post(apiv1_endpoint + '/solutions', data);

							case 3:
								result2 = _context.sent;


								console.log(result2);

								// adding a solution also gets us all the doubts again

								_context.next = 7;
								return context.dispatch('fetch_doubts');

							case 7:
								return _context.abrupt('return', {
									status: 'success'
								});

							case 10:
								_context.prev = 10;
								_context.t0 = _context['catch'](0);
								throw Error('Solution could not be added');

							case 13:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 10]]);
			}))();
		},
		login: function login(context, data) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var result2, user;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								//required data params
								// email, password.

								console.log('trying to login');

								_context2.prev = 1;
								_context2.next = 4;
								return axios_instance.post(apiv1_endpoint + '/get-token', {
									user_id: data.email,
									password: data.password
								});

							case 4:
								result2 = _context2.sent;


								console.log(result2);

								//console.log(result);

								context.commit('setToken', result2.data.token);

								user = {
									is_logged_in: true
								};

								context.commit('setUser', user);

								return _context2.abrupt('return', {
									status: 'success'
								});

							case 12:
								_context2.prev = 12;
								_context2.t0 = _context2['catch'](1);

								console.log('got error', _context2.t0);
								return _context2.abrupt('return', {
									status: 'failure',
									error: 'You have entered incorrect credentials!'
								});

							case 16:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[1, 12]]);
			}))();
		},
		logout: function logout(context) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return context.commit('removeToken');

							case 2:
								context.commit('setUser', { is_logged_in: false });

							case 3:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		fetch_me: function fetch_me(context) {
			var _this4 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.prev = 0;
								_context4.next = 3;
								return axios_instance.get(apiv1_endpoint + '/me');

							case 3:
								result2 = _context4.sent;


								context.commit('setUser', result2.data[0]);

								_context4.next = 11;
								break;

							case 7:
								_context4.prev = 7;
								_context4.t0 = _context4['catch'](0);

								console.log(_context4.t0.toString());
								throw Error('Could not fetch user info');

							case 11:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4, [[0, 7]]);
			}))();
		},
		fetch_packages: function fetch_packages(context) {
			var _this5 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.prev = 0;
								_context5.next = 3;
								return axios_instance.get(apiv1_endpoint + '/packages');

							case 3:
								result2 = _context5.sent;

								console.log('store', result2);
								context.commit('setPackages', result2.data.data);

								_context5.next = 12;
								break;

							case 8:
								_context5.prev = 8;
								_context5.t0 = _context5['catch'](0);

								console.log(_context5.t0.toString());
								throw Error('Could not fetch the packages!');

							case 12:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5, [[0, 8]]);
			}))();
		},
		fetch_doubts: function fetch_doubts(context) {
			var _this6 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_context6.prev = 0;
								_context6.next = 3;
								return axios_instance.get(apiv1_endpoint + '/doubts/assigned');

							case 3:
								result2 = _context6.sent;


								context.commit('setDoubts', result2.data.data);

								_context6.next = 11;
								break;

							case 7:
								_context6.prev = 7;
								_context6.t0 = _context6['catch'](0);

								console.log(_context6.t0.toString());
								throw Error('Could not fetch the doubts!');

							case 11:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6, [[0, 7]]);
			}))();
		},
		fetch_doubt_attachment: function fetch_doubt_attachment(context, doubt_id) {
			var _this7 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_context7.prev = 0;
								_context7.next = 3;
								return axios_instance.get(apiv1_endpoint + '/doubts/' + doubt_id + '/attachment');

							case 3:
								result = _context7.sent;
								return _context7.abrupt('return', result);

							case 7:
								_context7.prev = 7;
								_context7.t0 = _context7['catch'](0);

								console.log(_context7.t0.toString());
								throw Error('Could not fetch the attachment for doubt!');

							case 11:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7, [[0, 7]]);
			}))();
		},
		fetch_doubt_solution: function fetch_doubt_solution(context, doubt_id) {
			var _this8 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								_context8.prev = 0;
								_context8.next = 3;
								return axios_instance.get(apiv1_endpoint + '/doubts/' + doubt_id + '/solution');

							case 3:
								result = _context8.sent;
								return _context8.abrupt('return', result);

							case 7:
								_context8.prev = 7;
								_context8.t0 = _context8['catch'](0);

								console.log(_context8.t0.toString());
								throw Error('Could not fetch the solution for doubt!');

							case 11:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee8, _this8, [[0, 7]]);
			}))();
		},
		fetch_doubt_solution_attachment: function fetch_doubt_solution_attachment(context, doubt_id) {
			var _this9 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
					while (1) {
						switch (_context9.prev = _context9.next) {
							case 0:
								_context9.prev = 0;
								_context9.next = 3;
								return axios_instance.get(apiv1_endpoint + '/doubts/' + doubt_id + '/solution/attachment');

							case 3:
								result = _context9.sent;
								return _context9.abrupt('return', result);

							case 7:
								_context9.prev = 7;
								_context9.t0 = _context9['catch'](0);

								console.log(_context9.t0.toString());
								throw Error('Could not fetch the solution attachment!');

							case 11:
							case 'end':
								return _context9.stop();
						}
					}
				}, _callee9, _this9, [[0, 7]]);
			}))();
		},
		fetch_transactions: function fetch_transactions(context) {
			var _this10 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
					while (1) {
						switch (_context10.prev = _context10.next) {
							case 0:
								_context10.prev = 0;
								_context10.next = 3;
								return axios_instance.get(apiv1_endpoint + '/transactions/');

							case 3:
								result = _context10.sent;


								context.commit('setTransactions', result.data.data);

								_context10.next = 11;
								break;

							case 7:
								_context10.prev = 7;
								_context10.t0 = _context10['catch'](0);

								console.log(_context10.t0.toString());
								throw Error('Could not fetch the solution attachment!');

							case 11:
							case 'end':
								return _context10.stop();
						}
					}
				}, _callee10, _this10, [[0, 7]]);
			}))();
		}
	}
});

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JOOt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K3HG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("H4WX");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a14d106_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("rAXC");
function injectStyle (ssrContext) {
  __webpack_require__("+FQu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a14d106"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a14d106_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "KS9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"solutions"}},[_c('div',{staticClass:"solution-wrapper"},[_c('b-container',{staticClass:"solution-header",attrs:{"fluid":""}},[(_vm.enable_filters)?_c('b-row',[_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Tag Subject")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Option A")]),_vm._v(" "),_c('option',{attrs:{"value":"b","disabled":""}},[_vm._v("Option B (disabled)")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Grouped Options"}},[_c('option',{domProps:{"value":{'C':'3PO'}}},[_vm._v("Option  object value")]),_vm._v(" "),_c('option',{domProps:{"value":{'R':'2D2'}}},[_vm._v("Another option with object value")])])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Chapter")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("A to Z")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Z to A")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Low Star")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("High Star")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Date")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Accending")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Decending")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"search","required":"","placeholder":"Query Name"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-button',{staticClass:"query-btn",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)])],1):_vm._e()],1),_vm._v(" "),_c('h4',[_vm._v("Unsolved Doubts")]),_vm._v(" "),_vm._l((_vm.unsolved_doubts),function(doubt,index){return _c('b-container',{key:doubt.id,staticClass:"solution-container",attrs:{"fluid":""}},[_c('b-link',{staticClass:"solution-link note",class:{'qds-active-border':doubt.doubt_status=='completed', noteactive:doubt.doubt_status=='completed'},attrs:{"to":'/dashboard/doubts/'+doubt.id}},[_c('b-row',[_c('b-col',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center"},attrs:{"lg":"2"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.get_human_date(doubt.created_at)))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('p',[_vm._v(_vm._s(doubt.title))]),_vm._v(" "),_c('p',{staticClass:"doubt-description"},[_c('span',{staticClass:"qds-dot qds-active"}),_vm._v(" "+_vm._s(doubt.description.slice(0,50))+"...")])]),_vm._v(" "),_c('b-col',{staticClass:"sol-rating",attrs:{"lg":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"1"}},[(doubt.doubt_status=='completed')?_c('span',{staticClass:"doubt-description sol-view"},[_vm._v("Solved")]):_c('span',{staticClass:"doubt-description sol-view"},[_vm._v("Pending")])])],1)],1)],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Krvr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd027a40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Gcsz");
function injectStyle (ssrContext) {
  __webpack_require__("JOOt")
  __webpack_require__("nlKB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd027a40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MHTT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-wrapper",attrs:{"id":"AddDoubt"}},[_c('div',{staticClass:"add-query"},[_c('h4',[_vm._v("Have a doubt?")]),_vm._v(" "),_c('div',{attrs:{"id":"the_form"}},[_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"exampleInput1","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"text","required":"","placeholder":"Query Title"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup2","label":"","label-for":"exampleInput2","description":""}},[_c('b-form-select',{model:{value:(_vm.form.tags),callback:function ($$v) {_vm.$set(_vm.form, "tags", $$v)},expression:"form.tags"}},_vm._l((_vm.doubt_tags),function(tag){return _c('option',{domProps:{"value":tag}},[_vm._v(_vm._s(_vm.capitalize(tag))+"\n          ")])}))],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup3","label":"","label-for":"exampleInput3","description":""}},[_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Type your doubt here","rows":3,"max-rows":6},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),_c('div',[_c('b-container',{staticClass:"shadow-1"},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"action",staticStyle:{"padding-left":"0"},attrs:{"sm":"12"}},[_c('b-dropdown',{attrs:{"variant":"link","no-caret":""}},[_c('template',{slot:"button-content"},[_c('img',{attrs:{"src":"/static/symbol.png"}}),_vm._v(" "),_c('a',{staticClass:"add-symbol",staticStyle:{"font-size":"1rem"},attrs:{"href":"#","id":"add-symbol"}},[_vm._v("Add Symbols")])]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"}},[_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('∆')}}},[_vm._v("∆")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('∏')}}},[_vm._v("∏")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('∑')}}},[_vm._v("∑")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('Ω')}}},[_vm._v("Ω")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('∂')}}},[_vm._v("∂")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('μ')}}},[_vm._v("μ")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('∫')}}},[_vm._v("∫")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('π')}}},[_vm._v("π")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('∞')}}},[_vm._v("∞")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('≈')}}},[_vm._v("≈")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('≠')}}},[_vm._v("≠")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('÷')}}},[_vm._v("÷")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('−')}}},[_vm._v("−")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('√')}}},[_vm._v("√")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){_vm.addSymbol('+')}}},[_vm._v("+")])])])],2)],1),_vm._v(" "),_c('b-col',{staticStyle:{"padding-left":"0","padding-right":"0"},attrs:{"sm":"12"}},[_c('br'),_vm._v(" "),_c('b-form-file',{attrs:{"state":Boolean(_vm.upload),"placeholder":"Choose a file..."},model:{value:(_vm.upload),callback:function ($$v) {_vm.upload=$$v},expression:"upload"}}),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn button-touchy",staticStyle:{"margin-top":"20px","margin-left":"0"},attrs:{"variant":"primary"},on:{"click":_vm.execute_add_doubt}},[_vm._v("Submit")])],1)],1)],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_scss__ = __webpack_require__("Viya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_free_regular_svg_icons__ = __webpack_require__("Yu89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome__ = __webpack_require__("U0v6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_toasted__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





























__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_svg_core__["library"].add(__WEBPACK_IMPORTED_MODULE_9__fortawesome_free_regular_svg_icons__["a" /* faTimesCircle */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["a" /* faCoffee */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["b" /* faAngleDown */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["c" /* faAngleUp */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["d" /* faQuestionCircle */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["e" /* faBook */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["f" /* faAt */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["g" /* faStickyNote */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["h" /* faGraduationCap */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["i" /* faCalculator */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["j" /* faRupeeSign */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["k" /* faStar */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["l" /* faShareAlt */], __WEBPACK_IMPORTED_MODULE_9__fortawesome_free_regular_svg_icons__["b" /* faBell */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["m" /* faHome */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["n" /* faBars */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome__["FontAwesomeIcon"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_toasted___default.a, {
  duration: 5000,
  theme: 'bubble'
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "NX0l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O09s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello bg-light",attrs:{"id":"login"}},[_c('div',{attrs:{"id":"login_wrapper"}},[_c('b-container',{staticClass:"margin-auto rounded",attrs:{"id":"hero"}},[_c('b-row',[_c('b-col',{staticClass:"bg-green ctl center hero-col",attrs:{"sm":"12","lg":"6"}},[_c('div',{attrs:{"id":"the_form"}},[_c('h1',{staticStyle:{"margin-bottom":"2rem"}},[_vm._v("Faculty Login")]),_vm._v(" "),_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"exampleInput1","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"email","required":"","placeholder":"Enter email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"exampleInput1","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"password","required":"","placeholder":"Password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('b-button',{staticClass:"btn-blue",attrs:{"size":"lg","variant":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("Login")]),_c('br'),_c('br')],1)],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Obml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoubtsAll_vue__ = __webpack_require__("YGC+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb46cca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoubtsAll_vue__ = __webpack_require__("lT45");
function injectStyle (ssrContext) {
  __webpack_require__("7lyR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cb46cca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoubtsAll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb46cca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoubtsAll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QQ9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Packages',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        qtitle: '',
        selected: null,
        doubt: ''
      },
      show_buy_package_screen: true, //show buy_package screen by default
      selected_package: {},
      buy_package_id: '',
      transaction_success: false, // show transaction success screen
      transaction_summary: {
        payment_id: '',
        transaction: ''
      }
    };
  },

  computed: {
    packages: function packages() {
      return this.$store.getters.get_packages;
    },
    user_info: function user_info() {
      return this.$store.getters.user;
    },
    calculated_credits: function calculated_credits() {
      if (this.user_info.credits.credit != null) {
        if (this.user_info.credits.debit != null) {
          return parseFloat(this.user_info.credits.credit) - parseFloat(this.user_info.credits.debit);
        } else return parseFloat(this.user_info.credits.credit);
      } else {
        return 0;
      }
    }
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var action;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.$store.commit('setLoader', true);
              _context.prev = 1;
              _context.next = 4;
              return this.$store.dispatch('fetch_packages');

            case 4:
              action = _context.sent;

              this.$store.commit('setLoader', false);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](1);

              this.$toasted.show('There was an error, please refresh!', { type: 'success' });

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 8]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    onSubmit: function onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    },
    capture_payment: function capture_payment(razorpay_response) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var razorpay_payment_id, result, result2;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                razorpay_payment_id = razorpay_response.razorpay_payment_id;
                _context2.prev = 1;

                _this.$store.commit('setLoader', true);
                _context2.next = 5;
                return _this.$store.dispatch('capture_payment', { razorpay_payment_id: razorpay_payment_id, package_id: _this.buy_package_id });

              case 5:
                result = _context2.sent;


                _this.transaction_summary = result.data.data;

                _context2.next = 9;
                return _this.$store.dispatch('fetch_me');

              case 9:
                result2 = _context2.sent;


                _this.show_buy_package_screen = false;
                _this.transaction_success = true;

                _this.$store.commit('setLoader', false);

                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](1);

                _this.$toasted.show("We had a problem processing your transaction, please try again!");

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[1, 15]]);
      }))();
    },
    buy_package: function buy_package(package_index) {
      console.log(package_index);
      this.selected_package = this.packages[package_index];
      this.buy_package_id = this.selected_package.id;
      var rzp_options = {
        key: "rzp_test_5KUgaV57XyIaIU",
        amount: this.selected_package.cost * 100,
        name: "QdsPro",
        description: "Buy Package " + this.selected_package.name,
        handler: this.capture_payment,
        theme: {
          color: "#262f3c"
        }
      };

      var rzp1 = new Razorpay(rzp_options);
      rzp1.open();
    }
  }
});

/***/ }),

/***/ "QZOA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RRA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_my_dropdown__ = __webpack_require__("+vjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UnsolvedDoubts',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      enable_filters: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    unsolved_doubts: function unsolved_doubts() {
      return this.$store.getters.unsolved_doubts;
    }
  },
  methods: {
    get_human_date: function get_human_date(d) {
      var mom = __WEBPACK_IMPORTED_MODULE_1_moment___default()(d);
      return mom.format('LL');
    }
  },
  selected: null,
  search: ''
});

/***/ }),

/***/ "Viya":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W/Ui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown__ = __webpack_require__("+vjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loader_vue__ = __webpack_require__("wd27");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DoubtView',
  components: {
    loader: __WEBPACK_IMPORTED_MODULE_5__Loader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      msg: 'Welcome to QdsProz',
      the_doubt: {
        title: '',
        description: '',
        created_at: '',
        doubt_status: '',
        solution: null,
        attachment_filename: ''
      },
      img_source: '',
      solution: {
        description: '',
        attachment_filename: ''
      },
      solution_img_source: '',
      solution_attachment_file_obj: null,
      form: {
        solution_description: ''
      }
    };
  },

  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.current_doubt.attachment_filename != null) {
                this.get_attachment();
              }

              if (this.current_doubt.doubt_status == 'completed') {
                this.get_solution();
                this.get_solution_attachment();
              }

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    doubts: function doubts() {
      return this.$store.getters.doubts;
    },
    current_doubt: function current_doubt() {
      var doubt_id = this.$route.params.id;
      //return this.$route.params.id;
      return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.doubts, { 'id': Number(doubt_id) });
    }
  },
  methods: {
    get_human_date: function get_human_date(d) {
      var mom = __WEBPACK_IMPORTED_MODULE_3_moment___default()(d);
      return mom.format('LL');
    },
    get_attachment: function get_attachment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var action, attachment, source;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.$store.dispatch('fetch_doubt_attachment', _this.current_doubt.id);

              case 2:
                action = _context2.sent;


                //var attachment = action.data;

                attachment = action.data.data;
                source = 'data:' + attachment.attachment_type + ';base64,' + attachment.attachment_data;


                _this.img_source = source;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    get_solution: function get_solution() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var action;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.$store.dispatch('fetch_doubt_solution', _this2.current_doubt.id);

              case 2:
                action = _context3.sent;


                _this2.solution = action.data.data[0];

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    execute_add_solution: function execute_add_solution() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var api_form, FR, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this3.form.solution_description == '')) {
                  _context5.next = 3;
                  break;
                }

                _this3.$toasted.show('Please type the solution', { type: 'error' });
                return _context5.abrupt('return');

              case 3:
                api_form = {
                  doubt_id: _this3.current_doubt.id,
                  description: _this3.form.solution_description
                };


                _this3.$store.commit('setLoader', true);

                if (!(_this3.solution_attachment_file_obj != null)) {
                  _context5.next = 11;
                  break;
                }

                FR = new FileReader();


                FR.onload = function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(ev) {
                    var result;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            console.log('file read success');
                            api_form.attachment = btoa(ev.target.result);
                            api_form.attachment_type = _this3.solution_attachment_file_obj.type;
                            _context4.prev = 3;
                            _context4.next = 6;
                            return _this3.$store.dispatch('add_solution', api_form);

                          case 6:
                            result = _context4.sent;

                            _this3.$toasted.show('Solution Added!', { type: 'success' });
                            _this3.get_solution();
                            _this3.get_solution_attachment();
                            _this3.$store.commit('setLoader', false);
                            //this.$router.push('/dashboard/solutions');
                            _context4.next = 17;
                            break;

                          case 13:
                            _context4.prev = 13;
                            _context4.t0 = _context4['catch'](3);

                            _this3.$store.commit('setLoader', false);
                            _this3.$toasted.show(_context4.t0.toString(), { type: 'error' });

                          case 17:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this3, [[3, 13]]);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }();

                FR.readAsBinaryString(_this3.solution_attachment_file_obj);

                _context5.next = 24;
                break;

              case 11:
                _context5.prev = 11;
                _context5.next = 14;
                return _this3.$store.dispatch('add_solution', api_form);

              case 14:
                result = _context5.sent;

                _this3.$toasted.show('Solution Added!', { type: 'success' });
                _this3.get_solution();
                _this3.get_solution_attachment();
                _this3.$store.commit('setLoader', false);

                _context5.next = 24;
                break;

              case 21:
                _context5.prev = 21;
                _context5.t0 = _context5['catch'](11);

                _this3.$toasted.show(_context5.t0.toString(), { type: 'error' });

              case 24:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this3, [[11, 21]]);
      }))();
    },
    get_solution_attachment: function get_solution_attachment() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var action, attachment, source;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return _this4.$store.dispatch('fetch_doubt_solution_attachment', _this4.current_doubt.id);

              case 3:
                action = _context6.sent;
                attachment = action.data.data;
                source = 'data:' + attachment.attachment_type + ';base64,' + attachment.attachment_data;


                _this4.solution_img_source = source;

                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](0);

                console.log(_context6.t0.toString());

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this4, [[0, 9]]);
      }))();
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.get_attachment();
      this.get_solution();
    }
  }
});

/***/ }),

/***/ "Xc1D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"package-wrapper",attrs:{"id":"Packages"}},[_c('div',{staticClass:"add-query"},[_c('b-container',{staticClass:"package-container",attrs:{"fluid":""}},[(_vm.show_buy_package_screen)?_c('b-row',{attrs:{"id":"buy_package"}},[_c('b-col',{attrs:{"lg":"12"}},[_c('h4',[_vm._v("You have "+_vm._s(_vm.calculated_credits)+" Credits Available!")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"12"}},[_c('p',[_vm._v("You can choose one of the plans below to purchase:")])]),_vm._v(" "),_vm._l((_vm.packages),function(a_package,index){return _c('b-col',{key:a_package.id,attrs:{"lg":"4"}},[_c('div',{staticClass:"package-item"},[_c('h3',{staticClass:"package-head"},[_vm._v(_vm._s(a_package.name))]),_vm._v(" "),_c('b-row',[_c('b',[_vm._v("Doubts: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(a_package.credits))])]),_vm._v(" "),_c('b',[_vm._v("Add on:")]),_vm._v(" "),_c('p',[_vm._v("- Tables upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Squares upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Cubes upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Unit Sheet")]),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn",attrs:{"to":"#","variant":"primary"},on:{"click":function($event){_vm.buy_package(index)}}},[_vm._v("Buy for ₹"+_vm._s(a_package.cost))])],1)])})],2):_vm._e(),_vm._v(" "),(_vm.transaction_success)?_c('b-row',{attrs:{"id":"transaction_success"}},[_c('b-col',[_c('h4',[_vm._v("Transaction Successful! You have "+_vm._s(_vm.calculated_credits)+" Credits available.")]),_vm._v(" "),_c('p',[_vm._v("We have received your payment, and now you can ask your doubts at your ease!")]),_vm._v(" "),_c('p',[_vm._v("Here is a summary of your transaction:")]),_vm._v(" "),_c('table',[_c('tr',[_c('td',[_vm._v("Payment Id:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.transaction_summary.payment_id))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Package Name:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selected_package.name))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Credits:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selected_package.credits))])])]),_c('br'),_vm._v(" "),_c('p',[_vm._v("Thanks a lot, we are awaiting your doubts, Go ahead!")]),_vm._v(" "),_c('b-button',{staticClass:"btn btn-blue",attrs:{"to":"/dashboard/add-doubt"}},[_vm._v("Ask a Doubt")])],1)],1):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YGC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_my_dropdown__ = __webpack_require__("+vjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DoubtsAll',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      enable_filters: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    doubts: function doubts() {
      return this.$store.getters.doubts;
    }
  },
  methods: {
    get_human_date: function get_human_date(d) {
      var mom = __WEBPACK_IMPORTED_MODULE_1_moment___default()(d);
      return mom.format('LL');
    }
  },
  selected: null,
  search: ''
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__("qSdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Dashboard__ = __webpack_require__("7TRK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_DoubtView__ = __webpack_require__("4+Of");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_Overview__ = __webpack_require__("K3HG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_AddDoubt__ = __webpack_require__("pnwR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Dashboard_Solutions__ = __webpack_require__("Z2GM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Dashboard_History__ = __webpack_require__("HaSq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_DoubtsAll__ = __webpack_require__("Obml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Dashboard_Packages__ = __webpack_require__("Z1Cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Dashboard_PackagesHistory__ = __webpack_require__("wI5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Dashboard_AssignedDoubts__ = __webpack_require__("123g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Dashboard_UnsolvedDoubts__ = __webpack_require__("//BD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Dashboard_Transactions__ = __webpack_require__("eZqr");

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */]
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Dashboard__["a" /* default */],
    children: [{
      path: 'doubts-all',
      component: __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_DoubtsAll__["a" /* default */]
    }, {
      path: 'add-doubt',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_AddDoubt__["a" /* default */]
    }, {
      path: 'solutions',
      component: __WEBPACK_IMPORTED_MODULE_8__components_Dashboard_Solutions__["a" /* default */]
    }, {
      path: 'history',
      component: __WEBPACK_IMPORTED_MODULE_9__components_Dashboard_History__["a" /* default */]
    }, {
      path: 'packages',
      component: __WEBPACK_IMPORTED_MODULE_11__components_Dashboard_Packages__["a" /* default */]
    }, {
      path: 'packages-history',
      component: __WEBPACK_IMPORTED_MODULE_12__components_Dashboard_PackagesHistory__["a" /* default */]
    }, {
      path: 'doubts/:id',
      component: __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_DoubtView__["a" /* default */]
    }, {
      path: 'assigned',
      component: __WEBPACK_IMPORTED_MODULE_13__components_Dashboard_AssignedDoubts__["a" /* default */]
    }, {
      path: 'unsolved',
      component: __WEBPACK_IMPORTED_MODULE_14__components_Dashboard_UnsolvedDoubts__["a" /* default */]
    }, {
      path: 'transactions',
      component: __WEBPACK_IMPORTED_MODULE_15__components_Dashboard_Transactions__["a" /* default */]
    }]
  }]
}));

/***/ }),

/***/ "Z1Cw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Packages_vue__ = __webpack_require__("QQ9q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dcc0433_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Packages_vue__ = __webpack_require__("Xc1D");
function injectStyle (ssrContext) {
  __webpack_require__("QZOA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dcc0433"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Packages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dcc0433_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Packages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z2GM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Solutions_vue__ = __webpack_require__("C8U/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216e46dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Solutions_vue__ = __webpack_require__("HHku");
function injectStyle (ssrContext) {
  __webpack_require__("1fK9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-216e46dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Solutions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216e46dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Solutions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z8WG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_my_dropdown__ = __webpack_require__("+vjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssignedDoubts',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      enable_filters: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    unsolved_doubts: function unsolved_doubts() {
      return this.$store.getters.unsolved_doubts;
    }
  },
  methods: {
    get_human_date: function get_human_date(d) {
      var mom = __WEBPACK_IMPORTED_MODULE_1_moment___default()(d);
      return mom.format('LL');
    }
  },
  selected: null,
  search: ''
});

/***/ }),

/***/ "ZISC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__remove_polyfill__ = __webpack_require__("AR89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__remove_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__remove_polyfill__);

//
//
//
//
//
//
//
//
//
//
//




/**
 * Get the dimensions of `$ele` ele.
 * @param {HTMLElement} $ele
 * @return {object} Object with `width` and `height` properties.
 */
function getSize($ele) {
  var $clone = $ele.cloneNode(true);
  var size = {};

  $clone.style.display = 'block';
  $clone.style.visibility = 'hidden';
  $clone.style.position = 'absolute';
  $ele.parentNode.insertBefore($clone, $ele);
  size.width = $clone.offsetWidth;
  size.height = $clone.offsetHeight;
  $clone.remove();

  return size;
}

/**
 * Set dropdown position.
 * @param {HTMLElement} $link - Html element will show the dropdown when it is pressed.
 * @param {HTMLElement} $dd - Dropdown html element.
 * @param {array} position - Dropdown position.
 */
function _setPosition($link, $dd, position, margin) {
  var refSize = getSize($link);
  var cornerPos = {};
  var outStyle = {};
  var origin = {};

  var _position = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(position, 4),
      p1 = _position[0],
      p2 = _position[1],
      p3 = _position[2],
      p4 = _position[3];

  var rect = $link.getBoundingClientRect();
  var refPos = { top: 0, left: 0 };
  var dpSize = getSize($dd);
  var parentPosition = document.defaultView.getComputedStyle($link.offsetParent).position;

  switch (parentPosition.toLowerCase()) {
    case 'fixed':
      refPos.left = rect.left - $link.offsetParent.offsetLeft;
      refPos.top = rect.top - $link.offsetParent.offsetTop;
      break;

    case 'absolute':
      var parentRect = $link.offsetParent.getBoundingClientRect();
      refPos.left = rect.left - parentRect.left;
      refPos.top = rect.top - parentRect.top;
      break;

    default:
      refPos.left = rect.left - $link.offsetParent.offsetLeft + window.pageXOffset;
      refPos.top = rect.top - $link.offsetParent.offsetTop + window.pageYOffset;
  }

  cornerPos.left = refPos.left;
  switch (p1) {
    case 'center':
      cornerPos.left += refSize.width / 2;
      break;

    case 'right':
      cornerPos.left += refSize.width;
      break;
  }

  cornerPos.top = refPos.top;
  switch (p2) {
    case 'center':
      cornerPos.top += refSize.height / 2;
      break;
    case 'bottom':
      cornerPos.top += refSize.height;
      break;
  }

  switch (p3) {
    case 'left':
      outStyle.left = Math.round(cornerPos.left);
      origin.left = 'left';
      break;

    case 'center':
      outStyle.left = Math.round(cornerPos.left - dpSize.width / 2);
      origin.left = 'center';
      break;

    default:
      outStyle.left = Math.round(cornerPos.left - dpSize.width);
      origin.left = 'right';
  }

  switch (p4) {
    case 'top':
      outStyle.top = Math.round(cornerPos.top);
      origin.top = 'top';
      break;

    case 'center':
      outStyle.top = Math.round(cornerPos.top - dpSize.height / 2);
      origin.top = 'center';
      break;

    default:
      outStyle.top = Math.round(cornerPos.top - dpSize.height);
      origin.top = 'bottom';
  }

  outStyle.left = outStyle.left + margin[0] + 'px';
  outStyle.top = outStyle.top + margin[1] + 'px';
  outStyle.transformOrigin = origin.left + ' ' + origin.top;
  outStyle.position = 'absolute';
  return outStyle;
}

var getWindow = function getWindow() {
  return window.document;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueMyDropdown',

  data: function data() {
    return {
      ddStyle: {}
    };
  },


  props: {
    // Dropdown visibility.
    visible: {
      required: true,
      type: Boolean
    },

    // Dropdown position.
    position: {
      required: false,
      type: Array,
      default: function _default() {
        return ['right', 'top', 'left', 'top'];
      }
    },

    // Dropdown animation.
    animation: {
      required: false,
      type: String,
      default: 'ani-slide'
    }
  },

  methods: {
    open: function open() {
      var _this = this;

      this.setPosition();
      getWindow().addEventListener('resize', this.resizeEvent);
      setTimeout(function () {
        return getWindow().addEventListener('click', _this.clickOutEvent);
      }, 10);
    },
    close: function close() {
      getWindow().removeEventListener('resize', this.resizeEvent);
      getWindow().removeEventListener('click', this.clickOutEvent);
    },
    resizeEvent: function resizeEvent() {
      this.setPosition();
    },
    clickOutEvent: function clickOutEvent(evt) {
      var $dd = this.$el.children[1];
      if (evt.target !== $dd && !$dd.contains(evt.target)) {
        this.$emit('clickout', evt);
      }
    },
    setPosition: function setPosition() {
      var $link = this.$el.children[0];
      var $dd = this.$el.children[1];
      this.ddStyle = _setPosition($link, $dd, this.position, [0, 0]);
      this.$emit('positioned', this.ddStyle);
    }
  },

  watch: {
    visible: function visible(isVisible) {
      if (isVisible) {
        this.open();
      } else {
        this.close();
      }
    }
  },

  mounted: function mounted() {
    if (this.visible) {
      this.open();
    }
  },
  destroyed: function destroyed() {
    getWindow().removeEventListener('resize', this.resizeEvent);
    getWindow().removeEventListener('click', this.clickOutEvent);
  }
});

/***/ }),

/***/ "cMuE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "duna":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dxfU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Dashboard"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('transition',{attrs:{"name":"fade"}},[(_vm.main_nav_visibility)?_c('b-col',{staticClass:"bg-blue",attrs:{"id":"main_nav","sm":"12"}},[_c('div',{staticClass:"only-desktop"},[_c('img',{staticClass:"scale",staticStyle:{"display":"block"},attrs:{"src":"/static/logo.png"}})]),_vm._v(" "),_c('div',{staticClass:"only-mobile",attrs:{"id":"mobile_user_info"}},[_c('div',{staticClass:"close",on:{"click":function($event){_vm.main_nav_visibility=false}}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":['far', 'times-circle']}})],1),_vm._v(" "),_c('div',{staticClass:"user_pic"},[_c('img',{staticClass:"scale",attrs:{"src":"/static/re.png"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"}},[_c('h3',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.user_info.full_name))]),_vm._v(" "),_c('b-link',{staticStyle:{"margin":"0 5px"},attrs:{"href":"#"}},[_vm._v("Your Account")]),_vm._v(" "),_c('b-link',{staticStyle:{"margin":"0 5px"},on:{"click":_vm.logout}},[_vm._v("Logout")])],1)]),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":""}},[_c('b-row',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse1",modifiers:{"collapse1":true}}],attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"question-circle"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('h6',{staticClass:"collapsible-heading"},[_vm._v("Queries")])]),_vm._v(" "),_c('b-col',{staticClass:"toggler",attrs:{"cols":"2"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"angle-up"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse1"}},[_c('ul',{staticClass:"collapsible-ul"},[_c('li',[_c('div',{on:{"click":function($event){_vm.goto('/dashboard/assigned')}}},[_c('b-link',{attrs:{"to":"/dashboard/assigned"}},[_vm._v("Assigned")])],1)]),_vm._v(" "),_c('li',[_c('div',{on:{"click":function($event){_vm.goto('/dashboard/doubts-all')}}},[_c('b-link',{attrs:{"to":"/dashboard/doubts-all"}},[_vm._v("History")])],1)])])])],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":"true"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"at"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('b-link',{attrs:{"disabled":""}},[_vm._v("Mailbox")])],1),_vm._v(" "),_c('b-col')],1)],1),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":"true"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"rupee-sign"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('div',{on:{"click":function($event){_vm.goto('/dashboard/transactions')}}},[_c('b-link',{staticClass:"normal-link",attrs:{"to":"/dashboard/transactions"}},[_vm._v("Reports/Earnings")])],1)]),_vm._v(" "),_c('b-col')],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"id":"main_wrapper"}},[_c('div',{staticClass:"shadow-1",staticStyle:{"display":"flex"},attrs:{"id":"top_bar"}},[_c('font-awesome-icon',{staticClass:"icon",staticStyle:{"padding":"6px","display":"block","flex-basis":"13%","align-self":"center","height":"100%","max-width":"35px"},attrs:{"icon":"bars"},on:{"click":function($event){_vm.main_nav_visibility= !_vm.main_nav_visibility}}}),_vm._v(" "),_c('b-navbar',{staticStyle:{"flex-basis":"100%","padding-left":"0"},attrs:{"toggleable":"md"}},[_c('b-navbar-nav',{},[_c('img',{staticClass:"only-mobile",staticStyle:{"width":"80px","display":"block"},attrs:{"src":"/static/logo.png"}})]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',{staticClass:"mobile-padding-10"},[_c('b-link',{attrs:{"to":"/dashboard"}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"home"}})],1)],1),_vm._v(" "),_c('b-nav-item',{staticClass:"mobile-padding-10"},[_c('b-dropdown',{staticClass:"top_bar_button",attrs:{"variant":"link","right":"","size":"lg","no-caret":""}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"icon-dropdown"},[_c('font-awesome-icon',{attrs:{"icon":['far', 'bell']}})],1)]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#","disabled":""}},[_vm._v("You have no notifications!")])],2)],1),_vm._v(" "),_c('b-nav-item',{staticClass:"only-desktop"},[_c('b-dropdown',{attrs:{"variant":"link","size":"lg","no-caret":""}},[_c('template',{staticClass:"top_bar_button",slot:"button-content"},[_c('div',{staticClass:"user_pic"},[_c('img',{staticClass:"scale",attrs:{"src":"/static/re.png"}})])]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"color-green",attrs:{"href":"#"}},[_vm._v("Your Account")]),_vm._v(" "),_c('b-link',{on:{"click":_vm.logout}},[_vm._v("Logout")])],2)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"main_content"}},[_c('router-view')],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eZqr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__ = __webpack_require__("lqtz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_073a032c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__ = __webpack_require__("CLu7");
function injectStyle (ssrContext) {
  __webpack_require__("cMuE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-073a032c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_073a032c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eglt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddDoubt',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        title: '',
        tags: 'quant',
        description: '',
        attachment: null
      },
      upload: null,
      doubt_tags: ['quant', 'di', 'verbal', 'gk', 'others']
    };
  },

  methods: {
    capitalize: function capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    onSubmit: function onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    },
    addSymbol: function addSymbol(symbol) {
      this.form.description += symbol;
    },
    upload_change: function upload_change(val) {
      console.log('upload:', val);
    },
    execute_add_doubt: function execute_add_doubt() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var FR, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.form.title == '')) {
                  _context2.next = 3;
                  break;
                }

                _this.$toasted.show('Please enter the doubt title', { type: 'error' });
                return _context2.abrupt('return');

              case 3:
                if (!(_this.form.description == '')) {
                  _context2.next = 6;
                  break;
                }

                _this.$toasted.show('Please enter the doubt description', { type: 'error' });
                return _context2.abrupt('return');

              case 6:

                _this.$store.commit('setLoader', true);
                console.log(_this.upload);

                if (!(_this.upload != null)) {
                  _context2.next = 14;
                  break;
                }

                FR = new FileReader();


                FR.onload = function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(ev) {
                    var result;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            console.log('file read success');
                            _this.form.attachment = btoa(ev.target.result);
                            _this.form.attachment_type = _this.upload.type;
                            _context.prev = 3;
                            _context.next = 6;
                            return _this.$store.dispatch('add_doubt', _this.form);

                          case 6:
                            result = _context.sent;

                            _this.$toasted.show('Doubt Added!', { type: 'success' });
                            _this.$store.commit('setLoader', false);
                            _this.$router.push('/dashboard/solutions');
                            _context.next = 16;
                            break;

                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](3);

                            _this.$store.commit('setLoader', false);
                            _this.$toasted.show(_context.t0.toString(), { type: 'error' });

                          case 16:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[3, 12]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }();

                FR.readAsBinaryString(_this.upload);

                _context2.next = 26;
                break;

              case 14:
                _context2.prev = 14;
                _context2.next = 17;
                return _this.$store.dispatch('add_doubt', _this.form);

              case 17:
                result = _context2.sent;

                _this.$toasted.show('Doubt Added!', { type: 'success' });
                _this.$store.commit('setLoader', false);
                _this.$router.push('/dashboard/solutions');
                _context2.next = 26;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2['catch'](14);

                _this.$toasted.show(_context2.t0.toString(), { type: 'error' });

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[14, 23]]);
      }))();
    }
  }

});

/***/ }),

/***/ "gGYk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hydq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'History',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        qtitle: '',
        selected: null,
        doubt: ''
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    }
  }
});

/***/ }),

/***/ "lT45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"solutions"}},[_c('div',{staticClass:"solution-wrapper"},[_c('b-container',{staticClass:"solution-header",attrs:{"fluid":""}},[(_vm.enable_filters)?_c('b-row',[_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Tag Subject")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Option A")]),_vm._v(" "),_c('option',{attrs:{"value":"b","disabled":""}},[_vm._v("Option B (disabled)")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Grouped Options"}},[_c('option',{domProps:{"value":{'C':'3PO'}}},[_vm._v("Option  object value")]),_vm._v(" "),_c('option',{domProps:{"value":{'R':'2D2'}}},[_vm._v("Another option with object value")])])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Chapter")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("A to Z")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Z to A")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Low Star")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("High Star")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Date")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Accending")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Decending")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"search","required":"","placeholder":"Query Name"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-button',{staticClass:"query-btn",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)])],1):_vm._e()],1),_vm._v(" "),_c('h4',[_vm._v("Doubt History")]),_vm._v(" "),_vm._l((_vm.doubts),function(doubt,index){return _c('b-container',{key:doubt.id,staticClass:"solution-container",attrs:{"fluid":""}},[_c('b-link',{staticClass:"solution-link note",class:{'qds-active-border':doubt.doubt_status=='completed', noteactive:doubt.doubt_status=='completed'},attrs:{"to":'/dashboard/doubts/'+doubt.id}},[_c('b-row',[_c('b-col',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center"},attrs:{"lg":"2"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.get_human_date(doubt.created_at)))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('p',[_vm._v(_vm._s(doubt.title))]),_vm._v(" "),_c('p',{staticClass:"doubt-description"},[_c('span',{staticClass:"qds-dot qds-active"}),_vm._v(" "+_vm._s(doubt.description.slice(0,50))+"...")])]),_vm._v(" "),_c('b-col',{staticClass:"sol-rating",attrs:{"lg":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"1"}},[(doubt.doubt_status=='completed')?_c('span',{staticClass:"doubt-description sol-view"},[_vm._v("Solved")]):_c('span',{staticClass:"doubt-description sol-view"},[_vm._v("Pending")])])],1)],1)],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqtz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown__ = __webpack_require__("+vjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Transactions',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      enable_filters: false,
      loader: true
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    transactions: function transactions() {
      return this.$store.getters.transactions;
    }
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('fetch_transactions');

            case 2:
              this.loader = false;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    get_human_date: function get_human_date(d) {
      var mom = __WEBPACK_IMPORTED_MODULE_3_moment___default()(d);
      return mom.format('LL');
    }
  },
  selected: null,
  search: ''
});

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        email: '',
        password: ''
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var credentials, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('submitted');

                credentials = {
                  email: _this.form.email,
                  password: _this.form.password
                };
                _context.next = 4;
                return _this.$store.dispatch('login', credentials);

              case 4:
                result = _context.sent;


                console.log('got result', result);

                if (result.status != "success") {
                  _this.$toasted.show("Uh Oh, that's not right!");
                } else {
                  _this.$toasted.show('Login Successful', { type: 'success' });
                  _this.$router.push('/dashboard');
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {

    var user = this.$store.getters.user;

    if (user.is_logged_in) {
      this.$router.replace('/dashboard');
    }
  }
});

/***/ }),

/***/ "nlKB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Hello',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        email: '',
        password: ''
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var credentials, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('submitted');

                credentials = {
                  email: _this.form.email,
                  password: _this.form.password
                };
                _context.next = 4;
                return _this.$store.dispatch('login', credentials);

              case 4:
                result = _context.sent;


                console.log('got result', result);

                if (result.status != "success") {
                  _this.$toasted.show("Uh Oh, that's not right!");
                } else {
                  _this.$toasted.show('Login Successful', { type: 'success' });
                  _this.$router.push('/dashboard');
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {

    var user = this.$store.getters.user;

    if (user.is_logged_in) {
      this.$router.replace('/dashboard');
    }
  }
});

/***/ }),

/***/ "pl3Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pnwR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDoubt_vue__ = __webpack_require__("eglt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fedfa6b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDoubt_vue__ = __webpack_require__("MHTT");
function injectStyle (ssrContext) {
  __webpack_require__("IYGU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fedfa6b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDoubt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fedfa6b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDoubt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af05d14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("O09s");
function injectStyle (ssrContext) {
  __webpack_require__("pl3Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4af05d14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af05d14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rAXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Overview"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tjWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"package-wrapper",attrs:{"id":"History"}},[_c('div',{staticClass:"add-query"},[_c('h2',[_vm._v("Packages")]),_vm._v(" "),_c('b-container',{staticClass:"package-container",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"package-item"},[_c('h3',{staticClass:"package-head"},[_vm._v("Newbie")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Q:")]),_vm._v(" "),_c('span',[_vm._v("200")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("R:")]),_vm._v(" "),_c('span',[_vm._v("5000/-")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Add on:")]),_vm._v(" "),_c('p',[_vm._v("- Tables upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Squares upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Cubes upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Unit Sheet")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Description")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\ntempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\nquis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\nconsequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\ncillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\nproident, sunt in culpa qui officia deserunt mollit anim id est laborum.")])])],1),_vm._v(" "),_c('b-button',{staticClass:"query-btn",attrs:{"to":"#","variant":"primary"}},[_vm._v("Know More")])],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uExR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Loader'
});

/***/ }),

/***/ "ume5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PackageHistory',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        qtitle: '',
        selected: null,
        doubt: ''
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    }
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wI5S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackagesHistory_vue__ = __webpack_require__("ume5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_855a0fda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackagesHistory_vue__ = __webpack_require__("I3Is");
function injectStyle (ssrContext) {
  __webpack_require__("Krvr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-855a0fda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackagesHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_855a0fda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackagesHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wP4/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wd27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__("uExR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54077a43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__("9jM+");
function injectStyle (ssrContext) {
  __webpack_require__("y2FH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54077a43"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54077a43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    global_loader: function global_loader() {
      return this.$store.getters.global_loader;
    }
  },
  created: function created() {
    var token = localStorage.getItem('token');
    if (token) {
      var user = {
        is_logged_in: true
      };
      console.log('user is logged in');
      this.$router.replace('/dashboard');
      this.$store.commit('setUser', user);
      this.$store.commit('setToken', token);
    }
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3348a652_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("7j0/");
function injectStyle (ssrContext) {
  __webpack_require__("gGYk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3348a652"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3348a652_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y2FH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9934a9ae0a872de6f371.js